// extracted by mini-css-extract-plugin
export default {"content":"style_content__uZ4oa","itemName":"style_itemName__zb9Vr"};